import styled from 'styled-components'

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 16px;
	margin: 16px 0;
`
